import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext } from '../../shared';
import { CenterNavLinkItem } from '../../styles/desktop';
import { VisuallyHidden } from '../../styles/root';

var CenterNavLink = function CenterNavLink(_ref) {
  var isActive = _ref.isActive,
      setActiveNavItem = _ref.setActiveNavItem,
      index = _ref.index,
      navLink = _ref.navLink,
      activeLink = _ref.activeLink,
      hasSubmenu = _ref.hasSubmenu,
      flyOutHoverOutDelayTimer = _ref.flyOutHoverOutDelayTimer;

  var _useContext = useContext(HeaderContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  var text = navLink.text,
      href = navLink.href,
      useAbsolute = navLink.useAbsolute,
      _onClick = navLink.onClick,
      target = navLink.target;
  /* istanbul ignore next */

  var isActiveLink = (activeLink === null || activeLink === void 0 ? void 0 : activeLink.parent) === text && !(activeLink !== null && activeLink !== void 0 && activeLink.child);
  return /*#__PURE__*/React.createElement(CenterNavLinkItem, {
    href: useAbsolute ? href : envUrl + href,
    onClick: function onClick(e) {
      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            element: {
              name: 'nav shortcut',
              type: 'link',
              region_name: 'top nav',
              text: text,
              value: text.toLowerCase()
            },
            type: 'select'
          }
        }
      }));
      /* istanbul ignore next */

      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
    },
    target: target,
    "data-test": "".concat(dataTestPrefix, "-center-nav-link-").concat(index),
    hasSubmenu: hasSubmenu,
    isActive: isActive
    /** set the active state of link */
    ,
    onMouseOver: function onMouseOver() {
      /* istanbul ignore next */
      clearTimeout(flyOutHoverOutDelayTimer === null || flyOutHoverOutDelayTimer === void 0 ? void 0 : flyOutHoverOutDelayTimer.current);
      /* istanbul ignore else */

      if (!hasSubmenu && !isActive) setActiveNavItem && setActiveNavItem(index);
    }
    /** un-set the active state of link only if it was active */
    ,
    onMouseLeave: function onMouseLeave() {
      /* istanbul ignore else */
      if (!hasSubmenu && isActive) setActiveNavItem && setActiveNavItem(-1);
    },
    "aria-haspopup": hasSubmenu ? 'true' : 'false',
    "aria-expanded": hasSubmenu && isActive ? 'true' : 'false'
  }, isActiveLink && /*#__PURE__*/React.createElement(VisuallyHidden, null, "Current page: "), text);
};

CenterNavLink.displayName = 'DesktopCenterNavLink';
export default CenterNavLink;